import { render, staticRenderFns } from "./PortalUserTile.vue?vue&type=template&id=04aefaa7&scoped=true&"
import script from "./PortalUserTile.vue?vue&type=script&lang=js&"
export * from "./PortalUserTile.vue?vue&type=script&lang=js&"
import style0 from "./PortalUserTile.vue?vue&type=style&index=0&id=04aefaa7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aefaa7",
  null
  
)

export default component.exports